/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 連絡先情報
 */
export interface Szoa206aResponseElecAceptSearchResultDtoCncttoInfo {
    /**
     * 事前連絡コード：英数字<br>　コード変換マスターテーブル.画面項目ID「C000690」のユーザコードを設定
     */
    advtelCode?: string;
    /**
     * 事前連絡コード名称：全半角混在
     */
    advtelCodeAname?: string;
    /**
     * 連絡先需要者区分：英数字<br>　コード変換マスターテーブル.画面項目ID「C401050」のユーザコードを設定
     */
    cncttoCnsdiv?: string;
    /**
     * 連絡先需要者区分名称：全半角混在
     */
    cncttoCnsdivAname?: string;
    /**
     * 連絡先漢字氏名：全角
     */
    cncttoName?: string;
    /**
     * 連絡先カナ氏名：全角（カナ/数字/英字/スペース/記号）
     */
    cncttoKanaName?: string;
    /**
     * 連絡先電話番号コード：英数字<br>　コード変換マスターテーブル.画面項目ID「C000010」のユーザコードを設定
     */
    cncttoTeldv?: string;
    /**
     * 連絡先電話番号コード名称：全半角混在
     */
    cncttoTeldvAname?: string;
    /**
     * 連絡先電話番号：半角
     */
    cncttoTelNo?: string;
    /**
     * 連絡先住所コード：英数字
     */
    cncttoAddrcd?: string;
    /**
     * 連絡先郵便番号：数字
     */
    cncttoPostno?: string;
    /**
     * 連絡先都道府県名称：全角
     */
    cncttoPfcAname?: string;
    /**
     * 連絡先都道府県カナ名称：全角（カナ）
     */
    cncttoPfcKanaAname?: string;
    /**
     * 連絡先市区郡町村名称：全角
     */
    cncttoMptAname?: string;
    /**
     * 連絡先市区郡町村カナ名称：全角（カナ）
     */
    cncttoMptKanaAname?: string;
    /**
     * 連絡先町域名称：全角
     */
    cncttoTwareaAname?: string;
    /**
     * 連絡先町域カナ名称：全角（カナ）
     */
    cncttoTwareaKanaAname?: string;
    /**
     * 連絡先大字丁目名称：全角
     */
    cncttoOazaAname?: string;
    /**
     * 連絡先大字丁目カナ名称：全角（カナ）
     */
    cncttoOazaKanaAname?: string;
    /**
     * 連絡先番地：数字
     */
    cncttoBanti?: string;
    /**
     * 連絡先番地区分：英数字<br>　コード変換マスターテーブル.画面項目ID「C008870」のユーザコードを設定
     */
    cncttoBntdiv?: string;
    /**
     * 連絡先番地区分名称：全半角混在
     */
    cncttoBntdivAname?: string;
    /**
     * 連絡先番地区分カナ名称：全半角混在
     */
    cncttoBntdivKanaAname?: string;
    /**
     * 連絡先号：数字
     */
    cncttoGou?: string;
    /**
     * 連絡先号区分：英数字<br>　コード変換マスターテーブル.画面項目ID「C008880」のユーザコードを設定
     */
    cncttoGoudiv?: string;
    /**
     * 連絡先号区分名称：全半角混在
     */
    cncttoGoudivAname?: string;
    /**
     * 連絡先号区分カナ名称：全半角混在
     */
    cncttoGoudivKanaAname?: string;
    /**
     * 連絡先分筆号：英数字
     */
    cncttoBunptGou?: string;
    /**
     * 連絡先住宅・棟号漢字名：全角
     */
    cncttoSupadrAname?: string;
    /**
     * 連絡先住宅・棟号カナ名：全角（カナ/数字/英字/スペース/記号）
     */
    cncttoSupadrKananm?: string;
    /**
     * 連絡先屋号・業種漢字名：全角
     */
    cncttoYagouAname?: string;
    /**
     * 連絡先屋号・業種カナ名：全角（カナ/数字/英字/スペース/記号）
     */
    cncttoYagouKananm?: string;
    /**
     * 連絡先表示住所漢字：全角
     */
    cncttoAddrAnameF?: string;
    /**
     * 連絡先表示住所カナ：全角
     */
    cncttoAddrKanaAnameF?: string;
}

